<template>
    <div class="preview-window preview-wrapper">
        <v-container py-5 class="wrapper-container">
            <v-layout row wrap class="preview-return">
                <a @click="returnToEdit">Назад к оформлению</a>
            </v-layout>

            <v-layout row wrap class="preview-title">
                <h1>Предварительный просмотр</h1>
                <p >Пожалуйста, проверьте правильность введенных
                    данных:</p>
            </v-layout>

            <v-layout row wrap pt-3 class="preview-title">
                <h2>Эти данные будут в полисе. <br><u>Внимательно проверьте их!</u></h2>

            </v-layout>

            <v-layout row wrap>
                <v-flex xs4 sm3 pt-0 pb-2>
                    <span class="preview-text-label">Банк:</span><br>
                    {{ bankName }}
                </v-flex>
                <v-flex xs8 sm3 pt-0 pb-2>
                    <span class="preview-text-label">Остаток кредита:</span><br>
                    {{ precalcInfo.creditRemainder }}
                </v-flex>
                <v-flex xs8 sm3 pt-0 pb-2>
                    <span class="preview-text-label">Тип полиса:</span><br>
                    {{ policyType }}
                </v-flex>
            </v-layout>

            <h2 class="preview-subtitle">Кредитный договор</h2>
            <v-layout row wrap v-if="!calcInfo.noContractNumber">
                <v-flex xs4 sm3 pt-0 pb-2 v-if="calcInfo.contract.number">
                    <span class="preview-text-label">Номер договора:</span><br>
                    {{ calcInfo.contract.number }}
                </v-flex>
                <v-flex v-if="calcInfo.contract.mortgageRate" xs4 sm3 pt-0 pb-2>
                    <span class="preview-text-label">Ставка процента:</span><br>
                    {{ calcInfo.contract.mortgageRate }}%
                </v-flex>
                <v-flex v-if="calcInfo.contract.creditPercentBetRefus" xs4 sm6 pt-0 pb-2>
                    <span class="preview-text-label">Ставка процента при отказе от страхования:</span><br>
                    {{ calcInfo.contract.creditPercentBetRefus }}%
                </v-flex>
                <v-flex xs8 sm3 pt-0 pb-2 v-if="calcInfo.contract.dateStart">
                    <span class="preview-text-label">Дата начала:</span><br>
                    {{ calcInfo.contract.dateStart.split('-').reverse().join('.') }}
                </v-flex>
                <v-flex xs8 sm3 pt-0 pb-2 v-if="calcInfo.contract.dateEnd">
                    <span class="preview-text-label">Дата окончания:</span><br>
                    {{ calcInfo.contract.dateEnd.split('-').reverse().join('.') }}
                </v-flex>
                <v-flex xs8 sm3 pt-0 pb-2 v-if="calcInfo.contract.annuityPayment">
                    <span class="preview-text-label">Аннуитетный платеж:</span><br>
                    {{ calcInfo.contract.annuityPayment }}
                </v-flex>
            </v-layout>
            <v-layout row wrap v-else>
                <v-flex xs12 pt-0 pb-2>
                    Нет кредитного договора
                </v-flex>
            </v-layout>

            <h2 class="preview-subtitle">Срок действия полиса</h2>
            <v-layout row wrap>
                <v-flex xs8 sm3 pt-0 pb-2>
                    <span class="preview-text-label">Дата начала:</span><br>
                    {{ calcInfo.policyStartDate.split('-').reverse().join('.') }}
                </v-flex>
                <v-flex xs8 sm3 pt-0 pb-2 v-if="calcInfo.policyEndDate">
                    <span class="preview-text-label">Дата окончания полиса:</span><br>
                    {{ calcInfo.tempPolicyEndDate }}
                </v-flex>
                <v-flex xs8 sm3 pt-0 pb-2 v-if="calcInfo.policyEndDate">
                    <span class="preview-text-label">Дата окончания договора:</span><br>
                    {{ calcInfo.policyEndDate.split('-').reverse().join('.') }}
                </v-flex>
            </v-layout>

            <h2 class="preview-subtitle">Данные заёмщика:</h2>
            <v-layout row wrap>
                <v-flex xs12 pb-2>
                    <p>{{ calcInfo.fio.surname }} {{ calcInfo.fio.name }} {{ calcInfo.fio.patronymic }}</p>
                </v-flex>
                <v-flex xs12 sm4 md3 pt-0 pb-2>
                    <span class="preview-text-label">Дата рождения:</span><br>
                    {{ calcInfo.birthday.split('-').reverse().join('.') }}
                </v-flex>
                <v-flex xs12 sm4 md3 pt-0 pb-2>
                    <span class="preview-text-label">Рост:</span><br>
                    {{ calcInfo.height }} см
                </v-flex>
                <v-flex xs12 sm4 md3 pt-0 pb-2>
                    <span class="preview-text-label">Вес:</span><br>
                    {{ calcInfo.weight }} кг
                </v-flex>
                <v-layout row wrap v-if="calcInfo.upperPressure || calcInfo.lowerPressure">
                    <v-flex xs12 sm4 md3 pt-0 pb-2 v-if="calcInfo.upperPressure">
                        <span class="preview-text-label">Верхнее давление:</span><br>
                        {{ calcInfo.upperPressure }}
                    </v-flex>
                    <v-flex xs12 sm4 md3 pt-0 pb-2 v-if="calcInfo.lowerPressure">
                        <span class="preview-text-label">Нижнее давление:</span><br>
                        {{ calcInfo.lowerPressure }}
                    </v-flex>
                </v-layout>
                <v-flex xs12 pb-2>
                    <span class="preview-text-label">Паспорт:</span><br>
                    {{ calcInfo.passport.seriesNumber }} выдан {{ calcInfo.passport.issuedBy }} {{ calcInfo.passport.date.split('-').reverse().join('.') }}, код подразделения {{ calcInfo.passport.subdivisionCode }}
                </v-flex>
                <v-flex xs12 pb-2>
                    <span class="preview-text-label">Адрес регистрации:</span><br>
                    {{ calcInfo.registrationAddress.search }}
                </v-flex>
            </v-layout>

            <h2 class="preview-subtitle" v-if="precalcInfo.policyType.apartment">Данные по залоговой квартире</h2>
            <v-layout row wrap v-if="precalcInfo.policyType.apartment">
                <v-flex xs12 py-0 pt-0 pb-2>
                    <span class="preview-text-label">Адрес:</span><br>
                    {{ calcInfo.mortgageAddress.search }}
                </v-flex>
                <v-flex xs12 sm4 md3 pt-0 pb-2>
                    <span class="preview-text-label">Этажность дома:</span><br>
                    {{ calcInfo.floorsNumber }}
                </v-flex>
                <v-flex xs12 sm4 md3 pt-0 pb-2>
                    <span class="preview-text-label">Год постройки:</span><br>
                    {{ calcInfo.buildYear }}
                </v-flex>
                <v-flex xs12 sm4 md3 pt-0 pb-2>
                    <span class="preview-text-label">Площадь квартиры:</span><br>
                    {{ calcInfo.apartmentArea }}
                </v-flex>
            </v-layout>

            <v-container px-0 py-5>
                <v-layout pt-4 row wrap>
                    <v-flex xs12 sm6 md4>
                        <v-btn class="preview-button block"
                               @click="this.submit"
                        >
                            Всё верно!
                        </v-btn>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                        <v-btn class="preview-button block edit-button"
                               @click="this.returnToEdit"
                        >
                            Редактировать
                        </v-btn>
                    </v-flex>
                </v-layout>
            </v-container>

        </v-container>
    </div>
</template>

<script>
export default {
    name: 'MortgagePreview',
    props: ['precalcInfo', 'calcInfo'],

    computed: {
        bankName() {
            return this.precalcInfo.banks.find(item => item.alias == this.precalcInfo.bank).name
        },
        policyType() {
            let types = []
            this.precalcInfo.policyType.apartment ? types.push('Квартира') : {}
            this.precalcInfo.policyType.life ? types.push('Жизнь') : {}
            return types.join(', ')
        },
    },

    methods: {
        returnToEdit() {
            this.$emit('returnToEdit')
        },
        submit() {
            this.$emit('submit')
        }
    }

}
</script>

<style scoped>

.preview-wrapper {
    width: 100%;
    height: 600px;
    background-color: white;
    z-index: 999;
    position: fixed;
    top: 0px;
    overflow-y: auto;
}

.wrapper-container {
    max-width: 800px;
}

.preview-return {
    padding-top: 120px;
}

.preview-return a {
    text-decoration: underline;
}

.preview-button {
    color: #ffffff !important;
    line-height: 1.45 !important;
    font-weight: 700 !important;
    font-size: 19px !important;
    text-transform: none !important;
    box-shadow: none !important;

    height: 70px;
    width: 90%;
    background-color: #00ba57 !important;;
    text-align: center;
    padding: 0 30px !important;

    border-width: 1px;
    border-radius: 100px;
    border-color: transparent;
    border-style: solid;
}

.edit-button {
    color: black !important;
    background-color: white !important;
    border: solid 1px #c7c7c7;
}

/deep/ .preview-text-label {
    color: #585858;
    font-size: 12px;
}

.preview-title h1{
    padding: 27px 0;
}

.preview-title h2 {
    padding-bottom: 24px;
}

.preview-title p{
    font-size: 20px;
    padding: 5px 0
}

.preview-subtitle {
    padding: 24px 0;
}

@media screen and (max-width: 650px){
    .preview-title h1{
        font-size: 32px;
    }
    .preview-title p{
        font-size: 18px;
    }
}
</style>



// WEBPACK FOOTER //
// resources/js/components/mortgage/MortgagePreview.vue